import { render, staticRenderFns } from "./detalheLead.vue?vue&type=template&id=57c0a0f3&scoped=true&"
import script from "./detalheLead.vue?vue&type=script&lang=js&"
export * from "./detalheLead.vue?vue&type=script&lang=js&"
import style0 from "./detalheLead.vue?vue&type=style&index=0&id=57c0a0f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0a0f3",
  null
  
)

export default component.exports